/**
 * FAQ section — keep one accordion item open at a time.
 */
(function () {
  function closeSiblingAccordions(item, items) {
    items.forEach((other) => {
      if (other === item || !other.open) return;
      other.open = false;
    });
  }

  function initFaqAccordionBox(box) {
    const items = Array.from(box.querySelectorAll('details.faq-accordion'));
    if (items.length < 2) return;

    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (item.open) closeSiblingAccordions(item, items);
      });
    });
  }

  function initFaqAccordions(root = document) {
    root.querySelectorAll('.faq-accordion-box').forEach(initFaqAccordionBox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initFaqAccordions());
  } else {
    initFaqAccordions();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initFaqAccordions(event.target);
  });
})();
